import functions from "./functions.js";

$(function () {

    const $form = $('.form-contact');
    const form = $form[0];

    if (!form) {
        return;
    }

    $form.on('submit', e => {
        e.preventDefault();
        
        $form.addClass('processing');
        $form.find('button').prop('disabled', true);

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = 'hr';
        params['recaptchaType'] = 'enterprise';

        grecaptcha.enterprise.ready(function () {
            
            grecaptcha.enterprise.execute(functions.getRecaptchaKey(), { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);
                params['service_type'] = 'contact';

                $.post('/services/contact/', params).then(response => {
                   $form.removeClass('processing');
                    $form.find('button').prop('disabled', false);
                    $form.find(".done-message").removeClass('d-none').find('div').html(response.data);
                   
                    form.reset();
                    setTimeout(() => { 
                        $form.find(".done-message").addClass('d-none').find('div').html('');
                    }, 6000);

                }
            );
            });
        });

    });

});